<template>
  <v-row>
    <v-col cols="12">
      <v-row align="center">
        <v-col v-if="edit" class="text-center" style="color: white" cols="12">
          <h1>{{ character.statPoints }} Stat Points</h1>
          <br>
          Stats have a max of 15.
          <br>
          Primary stats cost 1 point each.
          <br>
          Tertiary stats cost 2 points each.
          <br>
          Dump stats cannot be increased.
        </v-col>
        <v-col cols="12">
          <v-row justify="center">
            <v-col v-for="stat in ['Physique', 'Finesse', 'Mind', 'Spirit']" cols="12" sm="3" :key="stat">
              <v-row align="center">
                <v-col cols="6" sm="12">
                  <v-row justify="center">
                    <avatarStat :traitType="stat" />
                  </v-row>
                  <v-row style="color: white" justify="center">
                    {{ statType(stat) }}
                  </v-row>
                </v-col>
                <v-col cols="6" sm="12">
                  <v-row justify="center">
                    <v-icon v-if="edit" dark @click="decrementStat(stat)" :disabled="character.dumpStats.includes(stat)">mdi-minus</v-icon>
                      <h1 style="color: white">
                        {{ character[stat.toLowerCase()] }}
                        <template v-if="statBonus(stat) > 0">
                          (+{{ statBonus(stat) }})
                        </template>
                      </h1>
                    <v-icon v-if="edit"  dark @click="incrementStat(stat)" :disabled="character.dumpStats.includes(stat)">mdi-plus</v-icon>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import _ from 'lodash';

export default {
  components: {
    avatarStat: () => import('../avatarStat')
  },
  props: {
    character: {
      type: Object,
      required: true
    },
    edit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      physique: _.cloneDeep(this.character.physique),
      finesse: _.cloneDeep(this.character.finesse),
      mind: _.cloneDeep(this.character.mind),
      spirit: _.cloneDeep(this.character.spirit)
    };
  },
  created() {
  },
  methods: {
    incrementStat(stat) {
      if (this.character[stat.toLowerCase()] > 14 && this.character.traits.includes('Exemplar')) {
        if (this.character.statPoints > 1 && this.character.primaryStats.includes(stat)) {
          this.character.statPoints -= 2;
          this.character[stat.toLowerCase()]++;
        } else if (this.character.statPoints > 3 && this.character.tertiaryStats.includes(stat)) {
          this.character.statPoints -= 4;
          this.character[stat.toLowerCase()]++;
        }
      } else if (this.character[stat.toLowerCase()] < 15) {
        if (this.character.statPoints > 0 && this.character.primaryStats.includes(stat)) {
          this.character.statPoints--;
          this.character[stat.toLowerCase()]++;
        } else if (this.character.statPoints > 1 && this.character.tertiaryStats.includes(stat)) {
          this.character.statPoints -= 2;
          this.character[stat.toLowerCase()]++;
        }
      }
    },
    decrementStat(stat) {
      let multiplier = 1;
      if (this.character[stat.toLowerCase()] > 15) {
        multiplier = 2;
      }
      if (this.character[stat.toLowerCase()] > this[stat.toLowerCase()]) {
        this.character[stat.toLowerCase()]--;
        if (this.character.primaryStats.includes(stat)) {
          this.character.statPoints += 1 * multiplier;
        } else {
          this.character.statPoints += 2 * multiplier;
        }
      }
    },
    statBonus(stat) {
      let bonus = 0;
      if (stat === 'Physique' && this.character.traits.includes('Mighty')) {
        bonus += 1;
      }
      if (stat === 'Finesse' && this.character.traits.includes('Limber')) {
        bonus += 1;
      }
      if (stat === 'Mind' && this.character.traits.includes('Clever')) {
        bonus += 1;
      }
      if (stat === 'Spirit' && this.character.traits.includes('Spiritual')) {
        bonus += 1;
      }
      if (stat === 'Physique' && this.character.traits.includes('Sturdy')) {
        bonus += 3;
      }
      if (stat === 'Finesse' && this.character.traits.includes('Quick')) {
        bonus += 3;
      }
      if (stat === 'Mind' && this.character.traits.includes('Thoughtful')) {
        bonus += 3;
      }
      if (stat === 'Spirit' && this.character.traits.includes('Willful')) {
        bonus += 3;
      }
      return bonus;
    },
    statType(stat) {
      if (this.character.primaryStats.includes(stat)) {
        return 'Primary';
      }
      if (this.character.tertiaryStats.includes(stat)) {
        return 'Tertiary';
      }

      return 'Dump';
    }
  },
  computed: {
  }
};
</script>

<style></style>
